import { render, staticRenderFns } from "./BaseSelect2.vue?vue&type=template&id=7455c8c8&scoped=true&"
import script from "./BaseSelect2.vue?vue&type=script&lang=js&"
export * from "./BaseSelect2.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelect2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BaseSelect2.vue?vue&type=style&index=1&id=7455c8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455c8c8",
  null
  
)

export default component.exports